import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: { boxSizing: 'border-box', width: '100%', overflow: 'clip', '&[data-state="open"]': { overflow: 'visible' } },
  body: { display: 'flow-root' }
}));
